export default __webpack_public_path__ + "static/media/dl.7c22db26.png";